<template>
  <div class="mine page">
    <div class="page-bg" ></div>
    <div class="wrapper">
      <van-pull-refresh
        v-model="isLoading"
        @refresh="onRefresh"
        :pulling-text="$t('refresh.pulling')"
        :loosing-text="$t('refresh.loosing')"
        :loading-text="$t('refresh.loading')"
      >
         <div class="header">
            <van-nav-bar class="nav-bar">
              <template #right>
                <van-icon name="chat-o" @click="toService()" color="#fff"/>
              </template>
            </van-nav-bar>
            <div class="user-wrapper" @click="doLogin()">
             <!-- <van-image round class="user_img" src="http://kongh5.hai18.top/img/avatar.b93a1df3.png">
               <template v-slot:loading>
                 <van-loading type="spinner"/>
               </template>
             </van-image> -->
             <!-- <van-image round class="user_img" :src="userInfo.header_img"> -->
             <van-image round class="user_img" src="/img/avatar.b93a1df3.png" >
                <template v-slot:loading>
                  <van-loading type="spinner"/>
                </template>
              </van-image>
              <div class="login-content">
                <p class="login-btn" >{{this.userInfo.username}}</p>
                <div class="rating-row">
                  <van-image class="vip-icon" src="/img/mine/vip.acd1744e.png">
                    <template v-slot:loading>
                      <van-loading type="spinner"/>
                    </template>
                  </van-image>
                  <span class="rating-text">{{$t("my.xin_score")}}{{ userInfo.credit_score !== undefined && userInfo.credit_score !== '' ? userInfo.credit_score : 80 }}</span>
                </div>

              </div>
            </div>
         </div>
         <div class="content">
            <div class="finance">

            <!-- <div class="finance-item"   @click="toService()">
              <van-icon class="icon"  name="peer-pay" />
              <span class="text">{{$t("my.recharge")}}</span>
            </div>
            <div class="line"></div> -->
            <div class="finance-item"  @click="doWithdrawal()">
               <van-image class="icon" src="/img/mine/1.png">
                 <template v-slot:loading>
                   <van-loading type="spinner"/>
                 </template>
               </van-image>
               <span class="text">{{$t("my.withdraw")}}</span>
             </div>
          </div>

            <div class="wallet">
              <div class="wallet-title">{{$t("my.my_balance")}}</div>
              <div class="wallet-row">
                <p class="balance">{{ this.userInfo.money }}</p>
                <div class="wallet-right">
                  <span class="wallet-unit">マーク</span>
                  <div class="refresh-btn">
                    <van-icon name="replay" />
                  </div>
                </div>
              </div>
            </div>

            <div :style="{ marginTop: menu_top +'px'}" class="menu" >
              <div class="menu-item" @click="$router.push({path:'/Infomation'});">
                <van-image class="menu-item-icon" src="/img/mine/nav1.png">
                  <template v-slot:loading>
                    <van-loading type="spinner"/>
                  </template>
                </van-image>
                <span class="menu-item-label" >{{$t("my.basic_information")}}</span>
              </div>

              <div class="menu-item" @click="$router.push({path:'/SetLoginPassword'});">
                <van-image class="menu-item-icon" src="/img/mine/nav7.png">
                  <template v-slot:loading>
                    <van-loading type="spinner"/>
                  </template>
                </van-image>
                <!-- <span class="menu-item-label" >{{$t("my.Login_password")}}</span> -->
                <span class="menu-item-label" >{{$t("my.Login_password")}}</span>
              </div>
              <div class="menu-item" @click="$router.push({path:'/GameRecord'});">
                <van-image class="menu-item-icon" src="/img/mine/baobiao.png">
                  <template v-slot:loading>
                    <van-loading type="spinner"/>
                  </template>
                </van-image>
                <span class="menu-item-label" >{{$t("my.task_log")}}</span>
              </div>
              <!-- <div class="menu-item" @click="$router.push({path:'/Infomation'});">
                <van-image class="menu-item-icon" src="/img/mine/user.svg">
                  <template v-slot:loading>
                    <van-loading type="spinner"/>
                  </template>
                </van-image>
                <span class="menu-item-label" >{{$t("my.personal_center")}}</span>
              </div> -->
              <div class="menu-item"  @click="toNotice()">
                <van-image class="menu-item-icon" src="/img/mine/4.png">
                  <template v-slot:loading>
                    <van-loading type="spinner"/>
                  </template>
                </van-image>
                <span class="menu-item-label" >{{$t("my.information_announcement")}}</span>
              </div>
              <div class="menu-item" @click="$router.push({path:'/ServiceOnline'});">
                <van-image class="menu-item-icon" src="/img/mine/5.png">
                  <template v-slot:loading>
                    <van-loading type="spinner"/>
                  </template>
                </van-image>
                <span class="menu-item-label" >{{$t("my.online_customer_service")}}</span>
              </div>

            </div>
            <div class="btn">
              <van-button color="linear-gradient(90deg,#6529c9,#cc2996)"  style="margin: 20px 0;font-size: 16px;padding:25px 0;width: 100%;border-radius: 14px;" @click="loginout()" >
                {{$t("setting.logout")}}
            </van-button>
            </div>
         </div>
      </van-pull-refresh>
    </div>
  </div>

</template>

<script>

export default {
  data() {
    return {
      userInfo:{
      },
      menu_top:40,
      isLoading: false,
    };
  },
  methods: {
    refresh(){
      this.isLoading = true;
      setTimeout(() => {
        this.isLoading = false;
        if(localStorage.getItem('token')){
          this.$toast(this.$t("reservation.refresh"));
        }else{
          this.$router.push({path:'/Login'})
        }
      }, 500);
    },
    exit(){
      this.$toast(this.$t("my.finish_task"));
    },
    showSetting() {
      if(localStorage.getItem('token')){
        this.$router.push({path:'/Setting'})
      }else{
        this.$router.push({path:'/Login'})
      }
    },
    toNotice(){
      if(localStorage.getItem('token')){
        this.$router.push({path:'/Notice'})
      }else{
        this.$router.push({path:'/Login'})
      }
    },
    onRefresh() {
      setTimeout(() => {
        this.isLoading = false;
        if(localStorage.getItem('token')){
            this.getUserInfo();
            this.$toast(this.$t("reservation.refresh"));
        }else{
            this.$router.push({path:'/Login'})
        }
      }, 500);
    },
    doLogin(){
        if(localStorage.getItem('token')){
            this.$router.push({path:'/Infomation'});
        }else {
            this.$router.push({path:'/Login'})
        }
    },
    doPay(){
      this.$router.push({
        name:'Recharge',
        params:{
          'balance':this.userInfo.money
        }
      })
    },
    doWithdrawal(){
      this.$http({
        method: 'get',
        url: 'user_get_bank'
      }).then(res=>{
          if(res.data.is_bank){
            this.$router.push("withdraw");
          }else {
            this.$router.push("Setbank");
            this.$toast.fail(this.$t("setting.set_bank"));
          }
      })
    },
    toService() {
      console.log(this.$store.getters.getBaseInfo)
      if(this.$store.getters.getBaseInfo.iskefu == 1){
        this.$router.push("ServiceOnline");
      }else {
        this.$toast.fail(this.$t("setting.forbid"));
      }
    },
    getUserInfo(){
      this.$http({
        method: 'get',
        url: 'user_info'
      }).then(res=>{
        if(res.code === 200){
          this.userInfo = res.data;
            console.log(this.userInfo);
            this.menu_top = 15;
            if(this.userInfo.status !== 1){
              this.$toast(this.$t("video.account_out"));
              localStorage.clear()
              this.$router.push({path:'/Login'})
            }
        }else if(res.code ===401){
          this.$toast(res.msg);
        }
      })
    },
    loginout() {
      localStorage.clear()
      this.$router.push({path:'/Login'});
    }
  },
  created() {
    if(localStorage.getItem('token')){
        this.getUserInfo();
    }else {
      this.userInfo.username = this.$t("setting.log_reg");
      this.userInfo.ip = this.$t("setting.more_service");
      this.userInfo.header_img = "img/mine/avatar.png";
    }
  }
};
</script>

<style scoped>
.page{
  position: absolute!important;
  top: 0;
  left: 0;
  right: 0;
  background-color: #f2f2f5;
}
.mine{
  position: relative;
    bottom: 20px;
    background: #f2f2f5;
    background: url('/img/usertop.660cec17.png') no-repeat top -16vw center;
    background-size: contain;
    padding-bottom: 7vw;
}
.mine .wrapper{
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}
.nav-bar{
  /* background: linear-gradient(
      90deg,#7e5678,#e6c3a1); */
      background: content-box;
}
.mine .header{

  padding-bottom: 100px;
  background-size: contain
}
::v-deep .van-nav-bar__content {
  height: 100px;
}
::v-deep .van-hairline--bottom::after {
  border-bottom-width: 0px;
}
.mine .header .van-nav-bar .van-icon {
  font-size: 45px;
}
.mine .header .user-wrapper{
  display: flex;
  align-items: center;
  margin: 0px 40px 0px 40px;

}
.mine .user_img{
  height: 130px;
  width: 130px;
}
::v-deep .van-loading__spinner {
  height: 50px;
  width: 50px;
}
::v-deep .van-image__error-icon {
  font-size: 70px;
}
.mine  .header .user-wrapper .login-content{
  flex: 1;
  margin-left: 30px;
}
.mine  .header .user-wrapper .login-content .login-btn{
  display: inline-block;
  font-size: 40px;
  line-height: 1;
  color: #fff;
}
.mine  .header .user-wrapper .login-content .rating-row{
  display: flex;
  align-items: center;
  margin-top: -10px;
}
.mine  .header .user-wrapper .login-content .vip-icon{
  width: 152px;
  height: 48px;
  flex: none;
}
.mine  .header .user-wrapper .login-content .rating-text{
  margin-left: 14px;
  color: #fff;
  font-size: 30px;
  line-height: 1;
  white-space: nowrap;
}
.mine .header .user-wrapper .login-content .login-label{
  margin-top: -13px;
  font-size: 28px;
  color: hsla(0,0%,100%,.6);
}
.mine .page-bg{
  height: 500px;

}
.mine .content{
  position: relative;
  padding: 10px 30px 30px;
  min-height: 500px;
  background-color: #f2f2f5;
}

::v-deep .van-pull-refresh__track .van-pull-refresh__head *{
  color: #ffffff;
  font-size: 35px;
}

.mine .wrapper .content .finance {
  position: absolute;
  display: flex;
  align-items: center;
  top: -55px;
  left: 30px;
  right: 30px;
  height: 120px;
  background-color: #fff;
  border-radius: 15px;
  box-shadow: 0 1.5px 1px 0 #e4e4e7;
}
.mine .wrapper .content .finance .line{
  width: 3px;
  height: 40px;
  background-color: #ccc;
}
.mine .wrapper .content .finance .finance-item{
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
.mine .wrapper .content .finance .finance-item .text{
  margin-left: 30px;
  font-size: 30px;
  color: #000;
  font-weight: 500;
}
.mine .wrapper .content .finance .finance-item .icon{
  width: 50px;
  height: 50px;
  object-fit: contain;
}
.mine .wrapper .content .menu{
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 8px 0;
  background-color: #fff;
  border-radius: 15px;
  box-shadow: 0 1.5px 1px 0 #e4e4e7;
  padding: 14px 0 18px;
}
.mine .wrapper .content .menu .menu-item{
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: 148px;
  height: auto;
  box-sizing: border-box;
}
.mine .wrapper .content .menu .menu-item .menu-item-label{
  margin-top: 12px;
  font-size: 22px;
  color: #432788;
  font-weight: 500;
  line-height: 1.15;
  text-align: center;
}
.mine .wrapper .content .menu .menu-item .menu-item-icon{
  margin: 0;
  width: 64px;
  height: 64px;
  -o-object-fit: contain;
  object-fit: contain;
}
.mine .wrapper .content .wallet{
  margin-top: 80px;
  position: relative;
  height: 158px;
  padding: 0;
  background-color: #a06098;
  border-radius: 15px;
  box-shadow: none;
  box-sizing: border-box;
}
.mine .wrapper .content .wallet .wallet-title{
  position: absolute;
  left: 24px;
  top: 20px;
  color: #fff;
  font-size: 28px;
  font-weight: 500;
  line-height: 1.1;
}
.mine .wrapper .content .wallet .wallet-row{
  position: absolute;
  left: 24px;
  right: 24px;
  bottom: 20px;
}
.mine .wrapper .content .wallet .font-primary-color{
  color: #fff;
  font-size: 32px;
}
.font-gray {
  color: #fff;
  font-size: 28px;
}
.mine .wrapper .content .wallet .wallet-right{
  position: absolute;
  right: 0;
  top: -18px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
}
.mine .wrapper .content .wallet .balance{
  max-width: calc(100% - 110px);
  margin: 0;
  font-size: 44px;
  color: #fff;
  font-weight: 700;
  line-height: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: clip;
}
.mine .wrapper .content .wallet .wallet-unit{
  color: #fff;
  font-size: 22px;
  line-height: 1;
  white-space: nowrap;
}
/* .mine .wrapper .content .wallet .van-hairline--bottom::after {
  border-bottom-width: 3px;
} */
.mine .wrapper .content .wallet .refresh-btn{
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  font-size: 24px;
  border-radius: 50%;
  color: #ffffff;
  background-color: #e6c3a1;
  flex: none;
}
.mine .wrapper .content .wallet .refresh-btn .van-icon{
  font-size: 22px;
}
.btn{
 margin: 40px 0;
}
</style>
